import { buildProps, definePropType, mutable } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Table from '../table.vue'
import {
  TableHeaderSearchProps,
  MainTableProps,
  TablePaginationProps
} from './index'

// tableProps
export const tableProps = buildProps({
  /**
   * @description table的loading
   */
  loading: {
    type: Boolean,
    default: false
  },
  /**
   * @description 头部props
   */
  headerSearchProps: {
    type: definePropType<TableHeaderSearchProps>(Object),
    default: () => mutable({} as const)
  },
  /**
   * @description main-table的props
   */
  tableProps: {
    type: definePropType<MainTableProps>(Object),
    default: () => mutable({} as const)
  },
  /**
   * @description 分页的props
   */
  paginationProps: {
    type: definePropType<TablePaginationProps>({}),
    default: () => mutable({} as const)
  }
} as const)

export const HEADER_SRARCH_HEIGHT = 36 // 头部高度
export const PAGINATION_HEIGHT = 60 // 分页高度
// props
export type TableProps = ExtractPropTypes<typeof tableProps>

// instance
export type TableInstance = InstanceType<typeof Table>
